module.exports = __webpack_public_path__ + "assets/zhuangfa.4c35e243.svg";